import type { IconData } from '@stacksjs/iconify-core'

export const paintPaletteSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24c0-12.427 10.076-22.5 22.505-22.5c11.44 0 20.71 8.83 22.265 19.474c.724 4.954-3.045 9.054-7.963 9.055c-.83 0-1.662-.018-2.454-.034l-.224-.005a74 74 0 0 0-2.429-.023c-1.59.02-2.571.16-3.045.396c-.996.498-1.909 2.075-1.11 4.024c.505 1.23.923 2.19 1.266 2.977l.037.086c.343.788.627 1.442.828 1.998c.206.57.355 1.115.395 1.698c.042.593-.035 1.137-.173 1.699c-.383 1.568-1.562 2.497-2.883 3.001c-1.285.49-2.869.654-4.51.654C11.576 46.5 1.5 36.427 1.5 24M28 19a5 5 0 1 0 0-10a5 5 0 0 0 0 10m-9 2.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M18.5 38a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default paintPaletteSolid
